// DocumentsLoader.jsx

import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import DescriptionIcon from '@mui/icons-material/Description';
import './CaseInsideTable.css';

const DocumentsLoader = () => {

    return (
            <div
                className="files-loader-container">
                <div className="files-loader-background">
                    <div className="files-loader-content">
                        <DescriptionIcon sx={{
                            fontSize: 80,
                            color: 'rgba(255, 255, 255, 0.9)',
                            mb: 2,
                            animation: 'pulseIcon 1.5s ease-in-out infinite',
                        }}/>
                        <span className="files-loader-text">ფაილები იტვირთება...</span>
                        <span className="files-loader-subtext">გთხოვთ დაელოდოთ</span>
                        <CircularProgress sx={{color: 'rgba(255, 255, 255, 0.8)'}}/>
                    </div>
                </div>
            </div>
    );
};

export default DocumentsLoader;
